import Footer from "./components/organisms/Footer";
import Routes from "./routes";

function App() {
  return (
    <>
      <Routes />
      <Footer />
    </>
  );
}

export default App;
